import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pcn-range',
  templateUrl: './pcn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PcnRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
